module.exports = __webpack_public_path__ + "static/media/red_dragon.445ef157.webp";